import React from 'react';

const SIZE_CLASS = {
    xs: 'h-4 w-4',
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-12 w-12',
};

/**
 * Single product-wide loading indicator.
 * Prefer ListLoadingSpinner on list/detail pages; use size="xs"|"sm" for compact inline use.
 */
export default function LoadingSpinner({
    size = 'md',
    label = null,
    text = null,
    className = '',
    inline = false,
}) {
    const message = label || text;
    const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;

    return (
        <div
            className={`flex flex-col items-center justify-center gap-3 ${inline ? '' : 'py-12'} ${className}`.trim()}
            role="status"
            aria-live="polite"
            aria-busy="true"
        >
            <div
                className={`animate-spin rounded-full border-b-2 border-purple-600 ${sizeClass}`}
                aria-hidden="true"
            />
            {message ? <p className="text-sm text-gray-600">{message}</p> : null}
        </div>
    );
}
